export const dummyBlocks = [
  {
    index: 1,
    blockID: "BLOCK-0001",
    timestamp: "2025-09-13T18:55:00Z",
    previousHash: "0000000000000",
    merkleRoot: "a9c13d...",
    payload: {
      MainTDR: {
        holderName: "Rahul Patil",
        locationOfLand: "Pimpri, Pune",
        fsiCreditSqm: 1500,
        documentHash: "hash_of_original_tdr_doc1"
      },
      utilisationHistory: [
        {
          date: "2025-08-20",
          utiliserName: "Skyline Builders",
          usedAt: "Wakad, Pune",
          surveyNo: "CTS 120/4",
          areaUtilizedSqm: 400,
          balanceAreaSqm: 1100,
          documentHash: "hash_of_utilisation_doc_1"
        },
        {
          date: "2025-09-10",
          utiliserName: "ABC Developers",
          usedAt: "Baner, Pune",
          surveyNo: "CTS 452/1",
          areaUtilizedSqm: 500,
          balanceAreaSqm: 600,
          documentHash: "hash_of_utilisation_doc_2"
        }
      ],
      meta: {
        createdBy: "PMRDA-Blockchain-Node-1"
      }
    },
    hash: "current_block_hash_1"
  },
  {
    index: 2,
    blockID: "BLOCK-0002",
    timestamp: "2025-09-13T19:15:00Z",
    previousHash: "current_block_hash_1",
    merkleRoot: "b8d91c...",
    payload: {
      MainTDR: {
        holderName: "Sunil Deshmukh",
        locationOfLand: "Kothrud, Pune",
        fsiCreditSqm: 2000,
        documentHash: "hash_of_original_tdr_doc2"
      },
      utilisationHistory: [
        {
          date: "2025-09-05",
          utiliserName: "City Infra",
          usedAt: "Karvenagar, Pune",
          surveyNo: "CTS 88/9",
          areaUtilizedSqm: 500,
          balanceAreaSqm: 1500,
          documentHash: "hash_of_utilisation_doc_3"
        },
        {
          date: "2025-09-12",
          utiliserName: "XYZ Constructions",
          usedAt: "Shivaji Nagar, Pune",
          surveyNo: "CTS 300/2",
          areaUtilizedSqm: 700,
          balanceAreaSqm: 800,
          documentHash: "hash_of_utilisation_doc_4"
        }
      ],
      meta: {
        createdBy: "PMRDA-Blockchain-Node-1"
      }
    },
    hash: "current_block_hash_2"
  },
  {
    index: 3,
    blockID: "BLOCK-0003",
    timestamp: "2025-09-14T10:30:00Z",
    previousHash: "current_block_hash_2",
    merkleRoot: "c7f12b...",
    payload: {
      MainTDR: {
        holderName: "Amit Jadhav",
        locationOfLand: "Hadapsar, Pune",
        fsiCreditSqm: 1800,
        documentHash: "hash_of_original_tdr_doc3"
      },
      utilisationHistory: [
        {
          date: "2025-09-01",
          utiliserName: "Prime Builders",
          usedAt: "Magarpatta, Pune",
          surveyNo: "CTS 500/7",
          areaUtilizedSqm: 600,
          balanceAreaSqm: 1200,
          documentHash: "hash_of_utilisation_doc_5"
        },
        {
          date: "2025-09-11",
          utiliserName: "Sunrise Developers",
          usedAt: "Koregaon Park, Pune",
          surveyNo: "CTS 256/3",
          areaUtilizedSqm: 400,
          balanceAreaSqm: 800,
          documentHash: "hash_of_utilisation_doc_6"
        }
      ],
      meta: {
        createdBy: "PMRDA-Blockchain-Node-2"
      }
    },
    hash: "current_block_hash_3"
  },
  {
    index: 4,
    blockID: "BLOCK-0004",
    timestamp: "2025-09-14T12:00:00Z",
    previousHash: "current_block_hash_3",
    merkleRoot: "d9e21f...",
    payload: {
      MainTDR: {
        holderName: "Priya Kulkarni",
        locationOfLand: "Viman Nagar, Pune",
        fsiCreditSqm: 2200,
        documentHash: "hash_of_original_tdr_doc4"
      },
      utilisationHistory: [
        {
          date: "2025-09-07",
          utiliserName: "Metro Constructions",
          usedAt: "Viman Nagar, Pune",
          surveyNo: "CTS 600/5",
          areaUtilizedSqm: 800,
          balanceAreaSqm: 1400,
          documentHash: "hash_of_utilisation_doc_7"
        },
        {
          date: "2025-09-13",
          utiliserName: "Pune Developers",
          usedAt: "Yerwada, Pune",
          surveyNo: "CTS 420/8",
          areaUtilizedSqm: 600,
          balanceAreaSqm: 800,
          documentHash: "hash_of_utilisation_doc_8"
        }
      ],
      meta: {
        createdBy: "PMRDA-Blockchain-Node-2"
      }
    },
    hash: "current_block_hash_4"
  },
  {
    index: 5,
    blockID: "BLOCK-0005",
    timestamp: "2025-09-14T14:20:00Z",
    previousHash: "current_block_hash_4",
    merkleRoot: "e4a32d...",
    payload: {
      MainTDR: {
        holderName: "Rohit Shinde",
        locationOfLand: "Baner, Pune",
        fsiCreditSqm: 1600,
        documentHash: "hash_of_original_tdr_doc5"
      },
      utilisationHistory: [
        {
          date: "2025-09-09",
          utiliserName: "Elite Builders",
          usedAt: "Baner, Pune",
          surveyNo: "CTS 310/2",
          areaUtilizedSqm: 500,
          balanceAreaSqm: 1100,
          documentHash: "hash_of_utilisation_doc_9"
        },
        {
          date: "2025-09-12",
          utiliserName: "Golden Constructions",
          usedAt: "Aundh, Pune",
          surveyNo: "CTS 122/6",
          areaUtilizedSqm: 400,
          balanceAreaSqm: 700,
          documentHash: "hash_of_utilisation_doc_10"
        }
      ],
      meta: {
        createdBy: "PMRDA-Blockchain-Node-3"
      }
    },
    hash: "current_block_hash_5"
  },
  {
    index: 6,
    blockID: "BLOCK-0006",
    timestamp: "2025-09-14T16:45:00Z",
    previousHash: "current_block_hash_5",
    merkleRoot: "f6b54c...",
    payload: {
      MainTDR: {
        holderName: "Sneha Deshpande",
        locationOfLand: "Kothrud, Pune",
        fsiCreditSqm: 1900,
        documentHash: "hash_of_original_tdr_doc6"
      },
      utilisationHistory: [
        {
          date: "2025-09-10",
          utiliserName: "Silverline Developers",
          usedAt: "Kothrud, Pune",
          surveyNo: "CTS 210/5",
          areaUtilizedSqm: 700,
          balanceAreaSqm: 1200,
          documentHash: "hash_of_utilisation_doc_11"
        },
        {
          date: "2025-09-13",
          utiliserName: "Skyline Builders",
          usedAt: "Deccan Gymkhana, Pune",
          surveyNo: "CTS 150/3",
          areaUtilizedSqm: 500,
          balanceAreaSqm: 700,
          documentHash: "hash_of_utilisation_doc_12"
        }
      ],
      meta: {
        createdBy: "PMRDA-Blockchain-Node-3"
      }
    },
    hash: "current_block_hash_6"
  }
];
